import FormErrorController from '../FormErrorController';
/**
 * Enables (and requires) the input only while the given radio button is selected.
 * Otherwise the input is cleared and disabled.
 */
export default class EnableIfRadioSelected {
    constructor(inputSelector, radioSelector) {
        this.inputSelector = inputSelector;
        this.radioSelector = radioSelector;
    }
    handleRadioChange() {
        const isSelected = this.radioElement.checked;
        this.inputElement.disabled = !isSelected;
        this.inputElement.required = isSelected;
        if (!isSelected) {
            this.inputElement.value = '';
            FormErrorController.removeError(this.inputElement);
        }
    }
    start() {
        this.inputElement = document.querySelector(this.inputSelector);
        this.radioElement = document.querySelector(this.radioSelector);
        if (!this.inputElement || !this.radioElement) {
            throw new Error('EnableIfRadioSelected: Input or radio element not found');
        }
        this.handleRadioChange();
        const radioGroup = document.querySelectorAll(`input[type=radio][name="${this.radioElement.name}"]`);
        for (const radio of radioGroup) {
            radio.addEventListener('change', this.handleRadioChange.bind(this));
        }
    }
}
